import { render, staticRenderFns } from "./CreateMultipleOrders.vue?vue&type=template&id=c29877fc"
import script from "./CreateMultipleOrders.vue?vue&type=script&lang=js"
export * from "./CreateMultipleOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports